export default class TicketMensagemTemplateWhatsApp24HorasProps {
  constructor({
    notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas,
    mensagemDeObrigatoriedadeDoEnvioDoTemplateDe24Horas,
    proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas,
    mensagemDeProibicaoDoEnvioDeMensagemDoAtendentePeloFatoDeOSolicitanteAindaNaoTerRespondidoOTemplateDe24Horas,
  } = {}) {
    this.notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas = notificarObrigatoriedadeDoEnvioDoTemplateDe24Horas
    this.mensagemDeObrigatoriedadeDoEnvioDoTemplateDe24Horas = mensagemDeObrigatoriedadeDoEnvioDoTemplateDe24Horas
    this.proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas = proibirEnvioDeMensagemDoAtendentePeloFatoDeAUltimaMensagemSerUmTemplateDe24Horas
    this.mensagemDeProibicaoDoEnvioDeMensagemDoAtendentePeloFatoDeOSolicitanteAindaNaoTerRespondidoOTemplateDe24Horas = mensagemDeProibicaoDoEnvioDeMensagemDoAtendentePeloFatoDeOSolicitanteAindaNaoTerRespondidoOTemplateDe24Horas
  }
}
